<template>
  <div class="w-full h-full grid md:grid-cols-2">
    <WelcomeComponent class="relative hidden md:flex" />
    <div>
      <!-- {{ preFilledData }}
      {{ userData }} -->
      <div
        v-if="!preFilledData.email"
        class="h-full w-full flex items-center justify-center"
      >
        <Loader />
      </div>
      <RegisterComponent
        v-else
        :preFilledData="preFilledData"
        hideAffiliation
        hideWhatsapp
        class="relative"
      />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/utils/Loader.vue'
import RegisterComponent from '../components/appComponent/RegisterComponent.vue'
import WelcomeComponent from '../components/appComponent/WelcomeComponent.vue'

export default {
  components: { Loader, WelcomeComponent, RegisterComponent },
  data() {
    return {
      preFilledData: {},
      userId: this.$route.query.userId,
      email: this.$route.query.email,
      userData: {},
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    async loadUserData() {
      let email = this.email
      // const userData = await this.$Events.sendDataRequestResolve('userData', {
      //   userReference: this.userId,
      // })
      // if (!userData) {
      //   this.$Events.dispatchEvent('Votre lien semble incorrecte.')
      //   // this.$router.push('/')
      //   return
      // }
      // this.userData = userData
      this.preFilledData = { email: email }
    },
  },
}
</script>
